import defaultMenuStyles from '../default.module.css';

import React, { forwardRef, useEffect, useState } from 'react';
import DropdownComponent from '../../../Widgets/Dropdown/DropdownComponent';
import PopupFormTemplate from '../../SchemeUI/PopupFormTemplate';
import { DefaultProtocolGroups } from '../../../../consts/protocol.consts';
import { getAllProtocols } from 'services/list.services';

const ProtocolSelectMenu = forwardRef(
  (
    {
      protocol,
      position = {
        top: 0 | undefined,
        right: 0 | undefined,
        bottom: 0 | undefined,
        left: 0 | undefined,
      },
      onClose,
      onSelect = undefined,
    },
    menuRef,
  ) => {
    const [selectedGroup] = useState(() => DefaultProtocolGroups.qualityControl);
    const [selectedProtocol, setSelectedProtocol] = useState(protocol?.id ?? '');
    const [protocolsOptions, setProtocolsOptions] = useState([]);

    useEffect(() => {
      selectedGroup && loadProtocols(selectedGroup);
    }, [selectedGroup]);

    const loadProtocols = async (id) => {
      const result = await getAllProtocols({ sorting: { field: 'name', type: 'asc' } }, id);
      setProtocolsOptions(result?.data ?? []);
      if (protocol?.id) setSelectedProtocol(protocol?.id);
      else setSelectedProtocol('');
    };

    const handleCloseClick = () => {
      if (onClose) onClose();
    };

    const handleSaveClick = () => {
      if (onSelect) onSelect(selectedProtocol);
    };

    return (
      <PopupFormTemplate
        ref={menuRef}
        position={position}
        disabled={!selectedGroup || !selectedProtocol}
        onSubmit={handleSaveClick}
        onClose={handleCloseClick}
      >
        <div className={defaultMenuStyles.formField}>
          <div className={defaultMenuStyles.label}>Выберите протокол:</div>
          <DropdownComponent
            items={protocolsOptions}
            keyItem={'id'}
            valueItem={'name'}
            selectedKey={selectedProtocol}
            onChange={(value) => {
              setSelectedProtocol(value);
            }}
            disabled={!selectedGroup}
          />
        </div>
      </PopupFormTemplate>
    );
  },
);

export default ProtocolSelectMenu;
